const CONSUMER_EMAIL_DOMAINS = new Set(["aol.com", "gmail.com", "googlemail.com", "hotmail.com", "icloud.com", "live.com", "me.com", "msn.com", "outlook.com", "proton.me", "protonmail.com", "yahoo.com", "ymail.com"])

function getEmailDomain(email: string) {
  const [, domain] = email.trim().toLowerCase().split("@")
  return domain ?? ""
}

export function isConsumerEmailDomain(email: string) {
  return CONSUMER_EMAIL_DOMAINS.has(getEmailDomain(email))
}

export function splitFullName(fullName: string) {
  const parts = fullName.trim().split(/\s+/).filter(Boolean)
  const [firstName = "", ...lastNameParts] = parts

  return {
    firstName,
    lastName: lastNameParts.join(" "),
  }
}
